module.exports = __webpack_public_path__ + "media/images/riders/SAM_DALE-91815840cc111e5c0058e273d98c9ea1.png";